import React from 'react';

const PartnersSection = () => {
  const partners = [
    { 
      name: "Zoho", 
      logo: "https://customer-assets.emergentagent.com/job_b0164874-5b53-4413-974f-7fbbe9c1ff4c/artifacts/fz7pvfdu_zoho%20logo.jpeg"
    },
    { 
      name: "AWS", 
      logo: "https://customer-assets.emergentagent.com/job_b0164874-5b53-4413-974f-7fbbe9c1ff4c/artifacts/gkj744e8_awslog.png"
    },
    { 
      name: "Shopify", 
      logo: "https://customer-assets.emergentagent.com/job_b0164874-5b53-4413-974f-7fbbe9c1ff4c/artifacts/ufq68233_shopify.png"
    }
  ];

  return (
    <section className="py-20 bg-black relative">
      {/* Top border accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#06B6D4]/30 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-[#06B6D4] text-sm font-medium tracking-wider uppercase mb-4 block">
            Our Partners
          </span>
          <h2 className="text-2xl lg:text-3xl font-semibold text-white">
            Trusted Technology Partners
          </h2>
        </div>

        {/* Partner Logos */}
        <div className="flex flex-wrap items-center justify-center gap-12 lg:gap-20">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="group flex items-center justify-center opacity-70 hover:opacity-100 transition-all duration-300"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="h-12 lg:h-16 w-auto object-contain"
                style={{ maxWidth: '180px' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
